import { parse } from 'flatted';

var ContentfulCache = /*#__PURE__*/function () {
  function ContentfulCache(cache) {
    this.cache = new Map(cache);
  }

  var _proto = ContentfulCache.prototype;

  _proto.clear = function clear() {
    this.cache.clear();
    return this;
  };

  _proto.extract = function extract() {
    return Array.from(this.cache.entries());
  };

  _proto.has = function has(key) {
    return this.cache.has(key);
  };

  _proto.read = function read(key) {
    return this.cache.get(key);
  };

  _proto.restore = function restore(cache) {
    if (!cache) {
      return this;
    }

    if (typeof cache === 'string') {
      var data = parse(cache);

      if (Symbol.iterator in Object(data)) {
        this.cache = new Map(data);
      }
    } else if (Array.isArray(cache)) {
      this.cache = new Map(cache);
    }

    return this;
  };

  _proto.write = function write(key, value) {
    this.cache.set(key, value);
    return this;
  };

  return ContentfulCache;
}();

export { ContentfulCache as default };